import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { SuvoUsersClientLibSettingsService } from '../../../shared/services/suvo-users-client-lib-settings/suvo-users-client-lib-settings.service';
import { IGlobalElements } from '../interfaces/global-elements.interface';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalElementsService {
  globalElements = signal<IGlobalElements>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly settings: SuvoUsersClientLibSettingsService,
  ) {}

  async init(tenantId: string) {
    const globalElements = await this.getGlobalElements(tenantId);

    console.log('GOT GLOBAL ELEMENTS:', globalElements);

    this.globalElements.set(globalElements);
  }

  async getGlobalElements(tenantId: string): Promise<IGlobalElements> {
    return (await lastValueFrom(
      this.http.get(`${this.settings.dataServiceApi}public-global-elements/${tenantId}`),
    )) as IGlobalElements;
  }
}
